export enum TransitionElement {
  IncreasedProportionOfCommutingByElectricBus = 'increased_proportion_of_commuting_by_electric_bus',
  IncreasedProportionOfWalkingAndCycling = 'increased_proportion_of_walking_and_cycling',
  TransferFromCarToRailway = 'transfer_from_car_to_railway',
  ImprovedUrbanPlanning = 'improved_urban_planning',
  IncreasedProportionOfNonTravelMeetingsAndServices = 'increased_proportion_of_non_travel_meetings_and_services',
  EcodrivingOfCars = 'ecodriving_of_cars',
  MoreEfficientCommutingByCar = 'more_efficient_commuting_by_car',
  CarPoolsAndRentalCars = 'car_pools_and_rental_cars',
  ImprovedVehicleTechnology = 'improved_vehicle_technology',
  ShiftToElectricVehicles = 'shift_to_electric_vehicles',
  IncreaseRenewableProportionInDiesel = 'increase_renewable_proportion_in_diesel',
  TransferFromHeavyTruckToElectricRailway = 'transfer_from_heavy_truck_to_electric_railway',
  TransferFromHeavyTruckToSea = 'transfer_from_heavy_truck_to_sea',
  ImprovedLoadFactorLightTrucks = 'improved_load_factor_light_trucks',
  ImprovedVehicleTechnologyLightTrucks = 'improved_vehicle_technology_light_trucks',
  RouteOptimisationLightTrucks = 'route_optimisation_light_trucks',
  BiofuelForHeavyTrucks = 'biofuel_for_heavy_trucks',
  ElectricLightTrucks = 'electric_light_trucks',
  MoreEfficientPassengerAirplanes = 'more_efficient_passenger_airplanes',
  MoreEfficientSeaFreightTransportation = 'more_efficient_sea_freight_transportation',
  ShiftToLngFuelForSeaFreightTransportation = 'shift_to_lng_fuel_for_sea_freight_transportation',
  BiofuelsForAirTransport = 'biofuels_for_air_transport',
  BiofuelsForSeaFreightTransport = 'biofuels_for_sea_freight_transport',
  BiofuelsForMilitaryTransport = 'biofuels_for_military_transport',
  ElectrificationOfDomesticSeaFreightTransport = 'electrification_of_domestic_sea_freight_transport',
  ElectrificationOfProductionInIronAndSteelIndustry = 'electrification_of_production_in_iron_and_steel_industry',
  BiofuelsReplacingCoal = 'biofuels_replacing_coal',
  ProductionUsingHydrogen = 'production_using_hydrogen',
  OptimisationOfConcrete = 'optimisation_of_concrete',
  BiofuelsForCementAndMineralIndustry = 'biofuels_for_cement_and_mineral_industry',
  ElectrificationOfProductionInCementAndConcreteIndustry = 'electrification_of_production_in_cement_and_concrete_industry',
  CcsForCementAndConcreteIndustry = 'ccs_for_cement_and_concrete_industry',
  RenewableHydrogen = 'renewable_hydrogen',
  RenewableRawMaterialsForRefineries = 'renewable_raw_materials_for_refineries',
  CcsCcuForRefineries = 'ccs_ccu_for_refineries',
  RenewableRawMaterialsForChemicalIndustry = 'renewable_raw_materials_for_chemical_industry',
  IncreasedUseOfRecycledPlastics = 'increased_use_of_recycled_plastics',
  CcsCcuForChemicalIndustry = 'ccs_ccu_for_chemical_industry',
  BiofuelsForPaperAndPulpIndustry = 'biofuels_for_paper_and_pulp_industry',
  ElectrificationOfProductionInPaperAndPulpIndustry = 'electrification_of_production_in_paper_and_pulp_industry',
  BiofuelsForMetalIndustry = 'biofuels_for_metal_industry',
  InertAnodes = 'inert_anodes',
  IncreasedUseOfRecycledMetal = 'increased_use_of_recycled_metal',
  BiofuelsForOtherIndustry = 'biofuels_for_other_industry',
  ElectrificationOfOtherIndustries = 'electrification_of_other_industries',
  OptimisingFertiliserUse = 'optimising_fertiliser_use',
  IncreasedEffectivenessByPlantBreedingAndCulturing = 'increased_effectiveness_by_plant_breeding_and_culturing',
  NitrificationReducers = 'nitrification_reducers',
  Rewetting = 'rewetting',
  IncreasedResourceEfficiency = 'increased_resource_efficiency',
  ReducedFoodWaste = 'reduced_food_waste',
  ChangedProduction = 'changed_production',
  FoodAdditives = 'food_additives',
  FertiliserFromAnAerobicDigestionInBiogasProduction = 'fertiliser_from_an_aerobic_digestion_in_biogas_production',
  ReduceEvaporationOfLiquidFertiliser = 'reduce_evaporation_of_liquid_fertiliser',
  ReducedProportionOfFossilWaste = 'reduced_proportion_of_fossil_waste',
  ShiftToBiofuelInDistrictHeating = 'shift_to_biofuel_in_district_heating',
  ReplacePeatWithBiofuels = 'replace_peat_with_biofuels',
  ShiftToResidualHeatInDistrictHeating = 'shift_to_residual_heat_in_district_heating',
  ShiftToHeatPumpsInDistrictHeating = 'shift_to_heat_pumps_in_district_heating',
  CcsFromWasteIncineration = 'ccs_from_waste_incineration',
  CcsFromSolidBiofuelsBeccs = 'ccs_from_solid_biofuels_beccs',
  HeatPumpsInSingleFamilyResidentialBuildings = 'heat_pumps_in_single_family_residential_buildings',
  EnergyEfficientSingleFamilyResidentialBuildingsRetrofitting = 'energy_efficient_single_family_residential_buildings_retrofitting',
  HeatPumpsInNonResidentialCommercialBuildings = 'heat_pumps_in_non_residential_commercial_buildings',
  EnergyEfficientNonResidentialCommercialBuildingsRetrofitting = 'energy_efficient_non_residential_commercial_buildings_retrofitting',
  HeatingSingleFamilyResidentialBuildingsWithRenewableSolidBiofuels = 'heating_single_family_residential_buildings_with_renewable_solid_biofuels',
  ShiftToBiogasHeatingOfNonResidentialCommercialBuildings = 'shift_to_biogas_heating_of_non_residential_commercial_buildings',
  ReducedUseOfSolvents = 'reduced_use_of_solvents',
  ReplacingSolventsWithAlternatives = 'replacing_solvents_with_alternatives',
  ImprovedEnergyEfficiencyAndHybridisationOfMobileMachinery = 'improved_energy_efficiency_and_hybridisation_of_mobile_machinery',
  EfficientUseOfMobileMachinery = 'efficient_use_of_mobile_machinery',
  ElectrificationOfMobileMachinery = 'electrification_of_mobile_machinery',
  MobileMachineryUsingBiofuels = 'mobile_machinery_using_biofuels',
  ReducedLeakage = 'reduced_leakage',
  EfficientTreatmentOfSewageWaterAndSludge = 'efficient_treatment_of_sewage_water_and_sludge',
  LowCarbonConstructionOfMultiFamilyResidentialHousing = 'low_carbon_construction_of_multi_family_residential_housing',
  PvOnRoofTops = 'pv_on_roof_tops',
  ShiftToDistrictHeatingInSingleFamilyHouses = 'shift_to_district_heating_in_single_family_houses',
  TransferFromCarToRemoteWorking = 'transfer_from_car_to_remote_working',
  EcodrivingOfTrucks = 'ecodriving_of_trucks',
  ShiftToElectricHeavyTrucks = 'shift_to_electric_heavy_trucks',
  EcodrivingOfLightTrucks = 'ecodriving_of_light_trucks',
  EcodrivingOfHeavyTrucks = 'ecodriving_of_heavy_trucks',
  MoreEfficientUseOfLivingArea = 'more_efficient_use_of_living_area',
  MoreEfficientUseOfCommercialArea = 'more_efficient_use_of_commercial_area',
  ImprovedVehicleTechnologyHeavyTrucks = 'improved_vehicle_technology_heavy_trucks',
  HydrogenForLightTrucks = 'hydrogen_for_light_trucks',
  HydrogenForHeavyTrucks = 'hydrogen_for_heavy_trucks',
  WindPower = 'wind_power',
  EnergyEfficientNewCommercialBuildings = 'energy_efficient_new_commercial_buildings',
  IncreasedRecycling = 'increased_recycling',
  EnergyEfficientNewHousing = 'energy_efficient_new_housing',
  ShiftToDistrictHeatingInBuildings = 'shift_to_district_heating_in_buildings',
  ShiftToDistrictHeatingInCommercialBuildings = 'shift_to_district_heating_in_commercial_buildings',
  LowCarbonConstructionOfNonResidentialCommercialBuildings = 'low_carbon_construction_of_non_residential_commercial_buildings',
  IncreasedEnergyRecoveryFromWaste = 'increased_energy_recovery_from_waste',
  ReducedProductionOfWaste = 'reduced_production_of_waste',
  HydrogenBlendedInTheGasMixForHeatingBuildings = 'hydrogen_blended_in_the_gas_mix_for_heating_buildings',
  ImprovedLoadFactorHeavyTrucks = 'improved_load_factor_heavy_trucks',
  HeatingNonResidentialCommercialBuildingsWithRenewableSolidBiofuels = 'heating_non_residential_commercial_buildings_with_renewable_solid_biofuels',
  ImprovedGridElectricity = 'improved_grid_electricity',
  LowCarbonConstructionOfBuildings = 'low_carbon_construction_of_buildings',
  HeatingHousingAndBuildingsWithRenewableSolidBiofuels = 'heating_housing_and_buildings_with_renewable_solid_biofuels',
  HeatPumpsInMultiFamilyResidentialBuildings = 'heat_pumps_in_multi_family_residential_buildings',
  EnergyEfficientMultiFamilyResidentialBuildingsRetrofitting = 'energy_efficient_multi_family_residential_buildings_retrofitting',
  HeatingMultiFamilyResidentialBuildingsWithRenewableSolidBiofuels = 'heating_multi_family_residential_buildings_with_renewable_solid_biofuels',
  ShiftToDistrictHeatingInMultiFamilyBuildings = 'shift_to_district_heating_in_multi_family_buildings',
  HeatPumpsInNonResidentialIndustrialBuildings = 'heat_pumps_in_non_residential_industrial_buildings',
  EnergyEfficientNonResidentialIndustrialBuildingsRetrofitting = 'energy_efficient_non_residential_industrial_buildings_retrofitting',
  ShiftToDistrictHeatingInIndustrialBuildings = 'shift_to_district_heating_in_industrial_buildings',
  HeatingNonResidentialIndustrialBuildingsWithRenewableSolidBiofuels = 'heating_non_residential_industrial_buildings_with_renewable_solid_biofuels',
  HeatPumpsInNonResidentialPublicBuildings = 'heat_pumps_in_non_residential_public_buildings',
  EnergyEfficientNonResidentialPublicBuildingsRetrofitting = 'energy_efficient_non_residential_public_buildings_retrofitting',
  ShiftToDistrictHeatingInPublicBuildings = 'shift_to_district_heating_in_public_buildings',
  HeatingNonResidentialPublicBuildingsWithRenewableSolidBiofuels = 'heating_non_residential_public_buildings_with_renewable_solid_biofuels',
  ReplacementOfFluorinatedGases = 'replacement_of_fluorinated_gases',
  DestructionOfFluorinatedGases = 'destruction_of_fluorinated_gases',
  IncreaseRenewableProportionInPetrol = 'increase_renewable_proportion_in_petrol',
  IncreasedProportionOfPublicTransportByTramsAndLightRail = 'increased_proportion_of_public_transport_by_trams_and_light_rail',
  ShiftToGasVehicles = 'shift_to_gas_vehicles',
  GasLightTrucks = 'gas_light_trucks',
  GasHeavyTrucks = 'gas_heavy_trucks',
  ShiftFromPassengerAirTransportToRailway = 'shift_from_passenger_air_transport_to_railway',
  BiofuelForLightTrucks = 'biofuel_for_light_trucks',
  ElectricPassengerAirplanes = 'electric_passenger_airplanes',
  ShiftToLngFuelForSeaPassengerTransportation = 'shift_to_lng_fuel_for_sea_passenger_transportation',
  MoreEfficientSeaPassengerTransportation = 'more_efficient_sea_passenger_transportation',
  ElectrificationOfDomesticSeaPassengerTransport = 'electrification_of_domestic_sea_passenger_transport',
  BiofuelsForSeaPassengerTransport = 'biofuels_for_sea_passenger_transport',
  SolarRooftops = 'solar_rooftops',
  SolarParks = 'solar_parks',
  ImportedGridElectricity = 'imported_grid_electricity',
  ImportedGridElectricityEmissionFactor = 'imported_grid_electricity_emission_factor',
  HydroReservoir = 'hydro_reservoir',
  WindOffshore = 'wind_offshore',
  WindOnshore = 'wind_onshore',
  GasFiredPowerPlants = 'gas_fired_power_plants',
  OilFiredPowerPlants = 'oil_fired_power_plants',
  CoalFiredPowerPlants = 'coal_fired_power_plants',
  CHPBiofuels = 'chp_biofuels',
  CHPCoal = 'chp_coal',
  CHPNaturalGas = 'chp_natural_gas',
  CHPOil = 'chp_oil',
  CHPWasteIncineration = 'chp_waste_incineration',
  DistrictHeatingBiofuel = 'district_heating_biofuel',
  DistrictHeatingHeatPumps = 'district_heating_heat_pumps',
  DistrictHeatingResidualHeat = 'district_heating_residual_heat',
  ImportedGridDistrictHeat = 'imported_grid_district_heat',
  ImportedGridDistrictHeatEmissionFactor = 'imported_grid_district_heat_emission_factor',
  IncreasedProportionOfPublicTransportByDieselBus = 'increased_proportion_of_public_transport_by_diesel_bus',
  IncreasedProportionOfPublicTransportByGasBus = 'increased_proportion_of_public_transport_by_gas_bus',
  ShiftToDistrictCoolingInSingleFamilyBuildings = 'shift_to_district_cooling_in_single_family_buildings',
  ShiftToDistrictCoolingInMultiFamilyBuildings = 'shift_to_district_cooling_in_multi_family_buildings',
  EnergyEfficientSingleFamilyResidentialBuildingsCooling = 'energy_efficient_single_family_residential_buildings_cooling',
  EnergyEfficientMultiFamilyResidentialBuildingsCooling = 'energy_efficient_multi_family_residential_buildings_cooling',
  EfficientUseSingleFamilyResidentialBuildingsCooling = 'efficient_use_single_family_residential_buildings_cooling',
  EfficientUseMultiFamilyResidentialBuildingsCooling = 'efficient_use_multi_family_residential_buildings_cooling',
  ShiftToSolarThermalInSingleFamilyBuildings = 'shift_to_solar_thermal_in_single_family_buildings',
  ShiftToSolarThermalInMultiFamilyBuildings = 'shift_to_solar_thermal_in_multi_family_buildings',
  ShiftToSolarThermalInPublicBuildings = 'shift_to_solar_thermal_in_public_buildings',
  ShiftToSolarThermalInCommercialBuildings = 'shift_to_solar_thermal_in_commercial_buildings',
  EnergyEfficientMultiFamilyResidentialBuildingsRetrofittingCooling = 'energy_efficient_multi_family_residential_buildings_retrofitting_cooling',
  EnergyEfficientNonResidentialCommercialBuildingsRetrofittingCooling = 'energy_efficient_non_residential_commercial_buildings_retrofitting_cooling',
  EnergyEfficientNonResidentialIndustrialBuildingsRetrofittingCooling = 'energy_efficient_non_residential_industrial_buildings_retrofitting_cooling',
  EnergyEfficientNonResidentialPublicBuildingsRetrofittingCooling = 'energy_efficient_non_residential_public_buildings_retrofitting_cooling',
  EnergyEfficientsingleFamilyResidentialBuildingsRetrofittingCooling = 'energy_efficient_single_family_residential_buildings_retrofitting_cooling',
  IncreasedProportionOfPublicTransportByHydrogenBus = 'increased_proportion_of_public_transport_by_hydrogen_bus',
  ShiftToDistrictCoolingInCommercialBuildings = 'shift_to_district_cooling_in_commercial_buildings',
  ShiftToDistrictCoolingInIndustrialBuildings = 'shift_to_district_cooling_in_industrial_buildings',
  ShiftToDistrictCoolingInPublicBuildings = 'shift_to_district_cooling_in_public_buildings',
  ShiftToElectricCargoBikes = 'shift_to_electric_cargo_bikes',
  ShiftToHydrogenVehicles = 'shift_to_hydrogen_vehicles',
  ShiftToSolarThermalInIndustrialBuildings = 'shift_to_solar_thermal_in_industrial_buildings',
  ShiftToElectricBikes = 'shift_to_electric_bikes',
  IncreasedProportionOfPublicTransportByLpgBus = 'increased_proportion_of_public_transport_by_lpg_bus',
  IncreasedProportionOfPublicTransportByPetrolBus = 'increased_proportion_of_public_transport_by_petrol_bus',
  BiofuelForDieselBuses = 'biofuel_for_diesel_buses',
  BiofuelForDieselRailFreight = 'biofuel_for_diesel_rail_freight',
  BiofuelForDieselRailPassenger = 'biofuel_for_diesel_rail_passenger',
  BiofuelForGasBuses = 'biofuel_for_gas_buses',
  BiofuelForGasVehicles = 'biofuel_for_gas_vehicles',
  BiofuelForLngShippingFreight = 'biofuel_for_lng_shipping_freight',
  BiofuelForLngShippingPassenger = 'biofuel_for_lng_shipping_passenger',
  BiofuelForPetrolBuses = 'biofuel_for_petrol_buses',
  BiofuelForPetrolHeavyTrucks = 'biofuel_for_petrol_heavy_trucks',
  BiofuelForPetrolLightTrucks = 'biofuel_for_petrol_light_trucks',
  BiofuelForPetrolMotorcycles = 'biofuel_for_petrol_motorcycles',
  ShiftToElectricFreightRail = 'shift_to_electric_freight_rail',
  ShiftToElectricMotorcycles = 'shift_to_electric_motorcycles',
  ShiftToElectricPassengerRail = 'shift_to_electric_passenger_rail',
  ShiftToHydrogenFreightRail = 'shift_to_hydrogen_freight_rail',
  ShiftToHydrogenPassengerRail = 'shift_to_hydrogen_passenger_rail',
  MoreEfficientFreightAirplanes = 'more_efficient_freight_airplanes',
  BiofuelsForFreightAirTransport = 'biofuels_for_freight_air_transport',
  ShiftFromFreightAirTransportToRailway = 'shift_from_freight_air_transport_to_railway',
  ElectricFreightAirplanes = 'electric_freight_airplanes',
  EnergyEfficientOtherAgricultureForestryFishingElectricAppliances = 'energy_efficient_other_agriculture_forestry_fishing_electric_appliances',
  EnergyEfficientOtherCommercialElectricAppliances = 'energy_efficient_other_commercial_electric_appliances',
  EnergyEfficientOtherIndustrialElectricAppliances = 'energy_efficient_other_industrial_electric_appliances',
  EnergyEfficientOtherInstitutionalElectricAppliances = 'energy_efficient_other_institutional_electric_appliances',
  EnergyEfficientOtherResidentialElectricAppliances = 'energy_efficient_other_residential_electric_appliances',
  EnergyEfficientStreetLighting = 'energy_efficient_street_lighting',
  ShiftToResidentialElectricCookingStoves = 'shift_to_residential_electric_cooking_stoves',
  ShiftToCommercialElectricCookingStoves = 'shift_to_commercial_electric_cooking_stoves',
  DistrictHeatingOil = 'district_heating_oil',
  DistrictHeatingWaste = 'district_heating_waste',
  DistrictHeatingGeothermalHeat = 'district_heating_geothermal_heat',
  DistrictHeatingCoal = 'district_heating_coal',
  ChpHydrogen = 'chp_hydrogen',
  ChpLandfillGas = 'chp_landfill_gas',
  DistrictHeatingBiogas = 'district_heating_biogas',
  DistrictHeatingNaturalGas = 'district_heating_natural_gas',
  SludgeFiredPowerPlants = 'sludge_fired_power_plants',
  ChpSludge = 'chp_sludge',
  ChpBiogas = 'chp_biogas',
  DistrictHeatingSolarThermal = 'district_heating_solar_thermal',
  DistrictHeatingSludge = 'district_heating_sludge',
  BiofuelFiredPowerPlants = 'biofuel_fired_power_plants',
  DistrictHeatingHydrogen = 'district_heating_hydrogen',
  DistrictHeatingWaterSourcedHeatPumps = 'district_heating_water_sourced_heat_pumps',
  ShiftToBiogasHeatingOfSingleFamilyResidentialBuildings = 'shift_to_biogas_heating_of_single_family_residential_buildings',
  HydrogenFiredPowerPlants = 'hydrogen_fired_power_plants',
  WasteFiredPowerPlants = 'waste_fired_power_plants',
  DistrictHeatingLandfillGas = 'district_heating_landfill_gas',
  BiogasInMethaneReformingForAmmoniaProduction = 'biogas_in_methane_reforming_for_ammonia_production',
  BiogasInMethaneReformingForHydrogenProduction = 'biogas_in_methane_reforming_for_hydrogen_production',
  BiomassInCarbonGasificationForHydrogenProduction = 'biomass_in_carbon_gasification_for_hydrogen_production',
  ShiftToBiogasEnergyInChemicalIndustries = 'shift_to_biogas_energy_in_chemical_industries',
  ShiftToBiogasEnergyInGlassIndustries = 'shift_to_biogas_energy_in_glass_industries',
  ShiftToBiogasEnergyInHydrogenRefinement = 'shift_to_biogas_energy_in_hydrogen_refinement',
  ShiftToBiogasEnergyInIronAndSteelIndustries = 'shift_to_biogas_energy_in_iron_and_steel_industries',
  ShiftToBiogasEnergyInPulpPaperAndPrintIndustries = 'shift_to_biogas_energy_in_pulp_paper_and_print_industries',
  ShiftToBiomassEnergyInChemicalIndustries = 'shift_to_biomass_energy_in_chemical_industries',
  ShiftToBiomassEnergyInGlassIndustries = 'shift_to_biomass_energy_in_glass_industries',
  ShiftToBiomassEnergyInHydrogenRefinement = 'shift_to_biomass_energy_in_hydrogen_refinement',
  ShiftToBiomassEnergyInIronAndSteelIndustries = 'shift_to_biomass_energy_in_iron_and_steel_industries',
  ShiftToBiomassEnergyInPetroleumRefinement = 'shift_to_biomass_energy_in_petroleum_refinement',
  ShiftToBiomassEnergyInPulpPaperAndPrintIndustries = 'shift_to_biomass_energy_in_pulp_paper_and_print_industries',
  ShiftToElectricArcFurnacesInSteelIndustries = 'shift_to_electric_arc_furnaces_in_steel_industries',
  ShiftToElectricityInChemicalIndustries = 'shift_to_electricity_in_chemical_industries',
  ShiftToElectricityInGlassIndustries = 'shift_to_electricity_in_glass_industries',
  ShiftToElectricityInHydrogenRefinement = 'shift_to_electricity_in_hydrogen_refinement',
  ShiftToElectricityInIronAndSteelIndustries = 'shift_to_electricity_in_iron_and_steel_industries',
  ShiftToElectricityInPulpPaperAndPrintIndustries = 'shift_to_electricity_in_pulp_paper_and_print_industries',
  ShiftToElectrolysisOfWaterForHydrogenProduction = 'shift_to_electrolysis_of_water_for_hydrogen_production',
  ShiftToHydrogenEnergyInChemicalIndustries = 'shift_to_hydrogen_energy_in_chemical_industries',
  ShiftToHydrogenEnergyInGlassIndustries = 'shift_to_hydrogen_energy_in_glass_industries',
  ShiftToHydrogenEnergyInIronAndSteelIndustries = 'shift_to_hydrogen_energy_in_iron_and_steel_industries',
  ShiftToHydrogenEnergyInPulpPaperAndPrintIndustries = 'shift_to_hydrogen_energy_in_pulp_paper_and_print_industries',
  ShiftToInertAnodesInAluminiumIndustries = 'shift_to_inert_anodes_in_aluminium_industries',
  EnergyEfficientCommercialLighting = 'energy_efficient_commercial_lighting',
  ImprovedVehicleTechnologyBuses = 'improved_vehicle_technology_buses',
  ShiftToLandfillGasRecovery = 'shift_to_landfill_gas_recovery',
  ShiftToCompostingOfOrganicWaste = 'shift_to_composting_of_organic_waste',
  ShiftToExportedCompostingOfOrganicWaste = 'shift_to_exported_composting_of_organic_waste',
}

/**
 * SUB CATEGORIES
 */
export const FossileFreeTransportsByCarList = [
  TransitionElement.IncreasedProportionOfCommutingByElectricBus,
  TransitionElement.IncreasedProportionOfWalkingAndCycling,
  TransitionElement.TransferFromCarToRailway,
  TransitionElement.ImprovedUrbanPlanning,
  TransitionElement.IncreasedProportionOfNonTravelMeetingsAndServices,
  TransitionElement.EcodrivingOfCars,
  TransitionElement.MoreEfficientCommutingByCar,
  TransitionElement.ImprovedVehicleTechnology,
  TransitionElement.ShiftToElectricVehicles,
  TransitionElement.IncreaseRenewableProportionInDiesel,
  TransitionElement.TransferFromCarToRemoteWorking,
  TransitionElement.IncreaseRenewableProportionInPetrol,
  TransitionElement.IncreasedProportionOfPublicTransportByTramsAndLightRail,
  TransitionElement.ShiftToGasVehicles,
  TransitionElement.IncreasedProportionOfPublicTransportByDieselBus,
  TransitionElement.IncreasedProportionOfPublicTransportByGasBus,
  TransitionElement.IncreasedProportionOfPublicTransportByHydrogenBus,
  TransitionElement.ShiftToHydrogenVehicles,
  TransitionElement.ShiftToElectricBikes,
  TransitionElement.IncreasedProportionOfPublicTransportByLpgBus,
  TransitionElement.IncreasedProportionOfPublicTransportByPetrolBus,
  TransitionElement.BiofuelForDieselBuses,
  TransitionElement.BiofuelForGasBuses,
  TransitionElement.BiofuelForGasVehicles,
  TransitionElement.BiofuelForPetrolBuses,
  TransitionElement.BiofuelForPetrolMotorcycles,
  TransitionElement.ShiftToElectricMotorcycles,
  TransitionElement.ImprovedVehicleTechnologyBuses,
] as const;
export type FossileFreeTransportsByCar = (typeof FossileFreeTransportsByCarList)[number];

export const FossileFreeFreightTransportList = [
  TransitionElement.TransferFromHeavyTruckToElectricRailway,
  TransitionElement.TransferFromHeavyTruckToSea,
  TransitionElement.ImprovedLoadFactorLightTrucks,
  TransitionElement.ImprovedVehicleTechnologyLightTrucks,
  TransitionElement.RouteOptimisationLightTrucks,
  TransitionElement.BiofuelForHeavyTrucks,
  TransitionElement.ElectricLightTrucks,
  TransitionElement.EcodrivingOfTrucks,
  TransitionElement.ShiftToElectricHeavyTrucks,
  TransitionElement.EcodrivingOfLightTrucks,
  TransitionElement.EcodrivingOfHeavyTrucks,
  TransitionElement.ImprovedVehicleTechnologyHeavyTrucks,
  TransitionElement.HydrogenForLightTrucks,
  TransitionElement.HydrogenForHeavyTrucks,
  TransitionElement.ImprovedLoadFactorHeavyTrucks,
  TransitionElement.GasLightTrucks,
  TransitionElement.GasHeavyTrucks,
  TransitionElement.BiofuelForLightTrucks,
  TransitionElement.ShiftToElectricCargoBikes,
  TransitionElement.BiofuelForPetrolHeavyTrucks,
  TransitionElement.BiofuelForPetrolLightTrucks,
] as const;
export type FossileFreeFreightTransport = (typeof FossileFreeFreightTransportList)[number];

export const OtherTransportList = [
  TransitionElement.MoreEfficientPassengerAirplanes,
  TransitionElement.MoreEfficientSeaFreightTransportation,
  TransitionElement.ShiftToLngFuelForSeaFreightTransportation,
  TransitionElement.BiofuelsForAirTransport,
  TransitionElement.BiofuelsForSeaFreightTransport,
  TransitionElement.BiofuelsForMilitaryTransport,
  TransitionElement.ElectrificationOfDomesticSeaFreightTransport,
  TransitionElement.ShiftFromPassengerAirTransportToRailway,
  TransitionElement.ElectricPassengerAirplanes,
  TransitionElement.ShiftToLngFuelForSeaPassengerTransportation,
  TransitionElement.MoreEfficientSeaPassengerTransportation,
  TransitionElement.ElectrificationOfDomesticSeaPassengerTransport,
  TransitionElement.BiofuelsForSeaPassengerTransport,
  TransitionElement.BiofuelForDieselRailFreight,
  TransitionElement.BiofuelForDieselRailPassenger,
  TransitionElement.BiofuelForLngShippingFreight,
  TransitionElement.BiofuelForLngShippingPassenger,
  TransitionElement.ShiftToElectricFreightRail,
  TransitionElement.ShiftToElectricPassengerRail,
  TransitionElement.ShiftToHydrogenFreightRail,
  TransitionElement.ShiftToHydrogenPassengerRail,
  TransitionElement.MoreEfficientFreightAirplanes,
  TransitionElement.BiofuelsForFreightAirTransport,
  TransitionElement.ElectricFreightAirplanes,
  TransitionElement.ShiftFromFreightAirTransportToRailway,
] as const;
export type OtherTransport = (typeof OtherTransportList)[number];

export const IronAndSteelList = [
  TransitionElement.ElectrificationOfProductionInIronAndSteelIndustry,
  TransitionElement.BiofuelsReplacingCoal,
  TransitionElement.ProductionUsingHydrogen,
  TransitionElement.ShiftToBiogasEnergyInIronAndSteelIndustries,
  TransitionElement.ShiftToBiomassEnergyInIronAndSteelIndustries,
  TransitionElement.ShiftToElectricArcFurnacesInSteelIndustries,
  TransitionElement.ShiftToElectricityInIronAndSteelIndustries,
  TransitionElement.ShiftToHydrogenEnergyInIronAndSteelIndustries,
] as const;
export type IronAndSteel = (typeof IronAndSteelList)[number];
export const CementAndConcreteList = [
  TransitionElement.OptimisationOfConcrete,
  TransitionElement.BiofuelsForCementAndMineralIndustry,
  TransitionElement.ElectrificationOfProductionInCementAndConcreteIndustry,
  TransitionElement.CcsForCementAndConcreteIndustry,
  TransitionElement.LowCarbonConstructionOfMultiFamilyResidentialHousing,
  TransitionElement.LowCarbonConstructionOfNonResidentialCommercialBuildings,
  TransitionElement.LowCarbonConstructionOfBuildings,
  TransitionElement.ShiftToBiogasEnergyInGlassIndustries,
  TransitionElement.ShiftToBiomassEnergyInGlassIndustries,
  TransitionElement.ShiftToElectricityInGlassIndustries,
  TransitionElement.ShiftToHydrogenEnergyInGlassIndustries,
] as const;
export type CementAndConcrete = (typeof CementAndConcreteList)[number];

export const RefineriesList = [
  TransitionElement.RenewableHydrogen,
  TransitionElement.RenewableRawMaterialsForRefineries,
  TransitionElement.CcsCcuForRefineries,
  TransitionElement.BiogasInMethaneReformingForHydrogenProduction,
  TransitionElement.BiomassInCarbonGasificationForHydrogenProduction,
  TransitionElement.ShiftToBiogasEnergyInHydrogenRefinement,
  TransitionElement.ShiftToBiomassEnergyInHydrogenRefinement,
  TransitionElement.ShiftToBiomassEnergyInPetroleumRefinement,
  TransitionElement.ShiftToElectricityInHydrogenRefinement,
  TransitionElement.ShiftToElectrolysisOfWaterForHydrogenProduction,
] as const;
export type Refineries = (typeof RefineriesList)[number];

export const ChemicalList = [
  TransitionElement.RenewableRawMaterialsForChemicalIndustry,
  TransitionElement.IncreasedUseOfRecycledPlastics,
  TransitionElement.CcsCcuForChemicalIndustry,
  TransitionElement.BiogasInMethaneReformingForAmmoniaProduction,
  TransitionElement.ShiftToBiogasEnergyInChemicalIndustries,
  TransitionElement.ShiftToBiomassEnergyInChemicalIndustries,
  TransitionElement.ShiftToElectricityInChemicalIndustries,
  TransitionElement.ShiftToHydrogenEnergyInChemicalIndustries,
] as const;
export type Chemical = (typeof ChemicalList)[number];

export const PaperAndPulpList = [
  TransitionElement.BiofuelsForPaperAndPulpIndustry,
  TransitionElement.ElectrificationOfProductionInPaperAndPulpIndustry,
  TransitionElement.ShiftToBiogasEnergyInPulpPaperAndPrintIndustries,
  TransitionElement.ShiftToBiomassEnergyInPulpPaperAndPrintIndustries,
  TransitionElement.ShiftToElectricityInPulpPaperAndPrintIndustries,
  TransitionElement.ShiftToHydrogenEnergyInPulpPaperAndPrintIndustries,
] as const;
export type PaperAndPulp = (typeof PaperAndPulpList)[number];

export const MetalsList = [
  TransitionElement.BiofuelsForMetalIndustry,
  TransitionElement.InertAnodes,
  TransitionElement.IncreasedUseOfRecycledMetal,
  TransitionElement.ShiftToInertAnodesInAluminiumIndustries,
] as const;
export type Metals = (typeof MetalsList)[number];

export const IndustryOtherList = [
  TransitionElement.BiofuelsForOtherIndustry,
  TransitionElement.ElectrificationOfOtherIndustries,
] as const;
export type IndustryOther = (typeof IndustryOtherList)[number];

export const AgriculturalLandList = [
  TransitionElement.OptimisingFertiliserUse,
  TransitionElement.IncreasedEffectivenessByPlantBreedingAndCulturing,
  TransitionElement.NitrificationReducers,
  TransitionElement.Rewetting,
] as const;
export type AgriculturalLand = (typeof AgriculturalLandList)[number];

export const AnimalDigestionList = [
  TransitionElement.IncreasedResourceEfficiency,
  TransitionElement.ReducedFoodWaste,
  TransitionElement.ChangedProduction,
  TransitionElement.FoodAdditives,
] as const;
export type AnimalDigestion = (typeof AnimalDigestionList)[number];

export const StorageOfFertilisersList = [
  TransitionElement.FertiliserFromAnAerobicDigestionInBiogasProduction,
  TransitionElement.ReduceEvaporationOfLiquidFertiliser,
] as const;
export type StorageOfFertilisers = (typeof StorageOfFertilisersList)[number];

export const ElectricityAndDistrictHeatingList = [
  TransitionElement.ReducedProportionOfFossilWaste,
  TransitionElement.ShiftToBiofuelInDistrictHeating,
  TransitionElement.ReplacePeatWithBiofuels,
  TransitionElement.ShiftToResidualHeatInDistrictHeating,
  TransitionElement.ShiftToHeatPumpsInDistrictHeating,
  TransitionElement.CcsFromWasteIncineration,
  TransitionElement.CcsFromSolidBiofuelsBeccs,
  TransitionElement.PvOnRoofTops,
  TransitionElement.ImprovedGridElectricity,
  TransitionElement.WindPower,
] as const;
export type ElectricityAndDistrictHeating = (typeof ElectricityAndDistrictHeatingList)[number];

export const LocalHeatingList = [
  TransitionElement.HeatPumpsInNonResidentialCommercialBuildings,
  TransitionElement.HeatPumpsInNonResidentialIndustrialBuildings,
  TransitionElement.HeatPumpsInNonResidentialPublicBuildings,
  TransitionElement.EnergyEfficientNonResidentialCommercialBuildingsRetrofitting,
  TransitionElement.EnergyEfficientNonResidentialIndustrialBuildingsRetrofitting,
  TransitionElement.EnergyEfficientNonResidentialPublicBuildingsRetrofitting,
  TransitionElement.ShiftToBiogasHeatingOfNonResidentialCommercialBuildings,
  TransitionElement.MoreEfficientUseOfCommercialArea,
  TransitionElement.EnergyEfficientNewHousing,
  TransitionElement.HydrogenBlendedInTheGasMixForHeatingBuildings,
  TransitionElement.HeatingNonResidentialCommercialBuildingsWithRenewableSolidBiofuels,
  TransitionElement.EnergyEfficientNewCommercialBuildings,
  TransitionElement.ShiftToDistrictHeatingInBuildings,
  TransitionElement.ShiftToDistrictHeatingInCommercialBuildings,
  TransitionElement.ShiftToDistrictHeatingInIndustrialBuildings,
  TransitionElement.ShiftToDistrictHeatingInPublicBuildings,
  TransitionElement.HeatingHousingAndBuildingsWithRenewableSolidBiofuels,
  TransitionElement.HeatingNonResidentialIndustrialBuildingsWithRenewableSolidBiofuels,
  TransitionElement.HeatingNonResidentialPublicBuildingsWithRenewableSolidBiofuels,
  TransitionElement.ShiftToSolarThermalInCommercialBuildings,
  TransitionElement.ShiftToSolarThermalInPublicBuildings,
  TransitionElement.ShiftToSolarThermalInIndustrialBuildings,
] as const;
export type LocalHeating = (typeof LocalHeatingList)[number];

export const LocalHeatingResidentialList = [
  TransitionElement.HeatPumpsInSingleFamilyResidentialBuildings,
  TransitionElement.HeatPumpsInMultiFamilyResidentialBuildings,
  TransitionElement.EnergyEfficientSingleFamilyResidentialBuildingsRetrofitting,
  TransitionElement.EnergyEfficientMultiFamilyResidentialBuildingsRetrofitting,
  TransitionElement.HeatingSingleFamilyResidentialBuildingsWithRenewableSolidBiofuels,
  TransitionElement.MoreEfficientUseOfLivingArea,
  TransitionElement.ShiftToDistrictHeatingInSingleFamilyHouses,
  TransitionElement.ShiftToDistrictHeatingInMultiFamilyBuildings,
  TransitionElement.HeatingMultiFamilyResidentialBuildingsWithRenewableSolidBiofuels,
  TransitionElement.ShiftToSolarThermalInSingleFamilyBuildings,
  TransitionElement.ShiftToSolarThermalInMultiFamilyBuildings,
] as const;
export type LocalHeatingResidential = (typeof LocalHeatingResidentialList)[number];

export const LocalCoolingResidentialList = [
  TransitionElement.ShiftToDistrictCoolingInSingleFamilyBuildings,
  TransitionElement.ShiftToDistrictCoolingInMultiFamilyBuildings,
  TransitionElement.EnergyEfficientSingleFamilyResidentialBuildingsCooling,
  TransitionElement.EnergyEfficientMultiFamilyResidentialBuildingsCooling,
  TransitionElement.EfficientUseSingleFamilyResidentialBuildingsCooling,
  TransitionElement.EfficientUseMultiFamilyResidentialBuildingsCooling,
  TransitionElement.EnergyEfficientMultiFamilyResidentialBuildingsRetrofittingCooling,
  TransitionElement.EnergyEfficientsingleFamilyResidentialBuildingsRetrofittingCooling,
] as const;
export type LocalCoolingResidential = (typeof LocalCoolingResidentialList)[number];

export const LocalCoolingList = [
  TransitionElement.EnergyEfficientNonResidentialCommercialBuildingsRetrofittingCooling,
  TransitionElement.EnergyEfficientNonResidentialIndustrialBuildingsRetrofittingCooling,
  TransitionElement.EnergyEfficientNonResidentialPublicBuildingsRetrofittingCooling,
  TransitionElement.ShiftToDistrictCoolingInCommercialBuildings,
  TransitionElement.ShiftToDistrictCoolingInIndustrialBuildings,
  TransitionElement.ShiftToDistrictCoolingInPublicBuildings,
] as const;
export type LocalCooling = (typeof LocalCoolingList)[number];

export const LocalOtherList = [
  TransitionElement.ShiftToCommercialElectricCookingStoves,
  TransitionElement.EnergyEfficientStreetLighting,
  TransitionElement.EnergyEfficientOtherAgricultureForestryFishingElectricAppliances,
  TransitionElement.EnergyEfficientOtherCommercialElectricAppliances,
  TransitionElement.EnergyEfficientOtherIndustrialElectricAppliances,
  TransitionElement.EnergyEfficientOtherInstitutionalElectricAppliances,
] as const;
export type LocalOther = (typeof LocalOtherList)[number];

export const LocalOtherResidentialList = [
  TransitionElement.ShiftToResidentialElectricCookingStoves,
  TransitionElement.EnergyEfficientOtherResidentialElectricAppliances,
  TransitionElement.EnergyEfficientCommercialLighting,
] as const;
export type LocalOtherResidential = (typeof LocalOtherResidentialList)[number];

export const SolventsList = [
  TransitionElement.ReducedUseOfSolvents,
  TransitionElement.ReplacingSolventsWithAlternatives,
  TransitionElement.ReplacementOfFluorinatedGases,
  TransitionElement.DestructionOfFluorinatedGases,
];
export type Solvents = (typeof SolventsList)[number];

export const MachineryList = [
  TransitionElement.ImprovedEnergyEfficiencyAndHybridisationOfMobileMachinery,
  TransitionElement.EfficientUseOfMobileMachinery,
  TransitionElement.ElectrificationOfMobileMachinery,
  TransitionElement.MobileMachineryUsingBiofuels,
];
export type Machinery = (typeof MachineryList)[number];

export const WasteList = [
  TransitionElement.ReducedLeakage,
  TransitionElement.EfficientTreatmentOfSewageWaterAndSludge,
  TransitionElement.IncreasedEnergyRecoveryFromWaste,
  TransitionElement.IncreasedRecycling,
  TransitionElement.ReducedProductionOfWaste,
  TransitionElement.ShiftToLandfillGasRecovery,
  TransitionElement.ShiftToCompostingOfOrganicWaste,
  TransitionElement.ShiftToExportedCompostingOfOrganicWaste,
] as const;
export type Waste = (typeof WasteList)[number];

/**
 * MAIN CATEGORIES
 */
export const TransportList = [
  ...FossileFreeTransportsByCarList,
  ...FossileFreeFreightTransportList,
  ...OtherTransportList,
] as const;
export type Transport = (typeof TransportList)[number];

export const IndustryList = [
  ...IronAndSteelList,
  ...CementAndConcreteList,
  ...RefineriesList,
  ...ChemicalList,
  ...PaperAndPulpList,
  ...MetalsList,
  ...IndustryOtherList,
] as const;
export type Industry = (typeof IndustryList)[number];
export const AgricultureList = [...AgriculturalLandList, ...AnimalDigestionList, ...StorageOfFertilisersList] as const;
export type Agriculture = (typeof AgricultureList)[number];
export const EnergyList = [
  ...ElectricityAndDistrictHeatingList,
  ...LocalHeatingList,
  ...LocalHeatingResidentialList,
  ...LocalCoolingResidentialList,
  ...LocalCoolingList,
  ...LocalOtherList,
  ...LocalOtherResidentialList,
] as const;
export type Energy = (typeof EnergyList)[number];
export const OtherList = [...SolventsList, ...MachineryList, ...WasteList] as const;
export type Other = (typeof OtherList)[number];
